/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Guarantor Demographics view model for retrieval (with patient only) or (direct) update
 */
export interface GuarantorDemographicsIntegrationViewModel {
  /**
   * Guarantor first name, max length 50
   */
  firstName?: string | null;
  /**
   * Guarantor middle name, max length 50
   */
  middleName?: string | null;
  /**
   * Guarantor last name, max length 50
   */
  lastName?: string | null;
  /**
   * Guarantor suffix, max length 20
   */
  suffix?: string | null;
  /**
   * Guarantor SSN, max length 11
   */
  ssn?: string | null;
  /**
   * Guarantor Date of Birth
   */
  birthDate?: string | null;
  /**
   * Guarantor Gender. (M)ale, (F)emale, (O)ther are valid values.
   */
  gender?: string | null;
  /**
   * Guarantor Address Line 1, max length 100
   */
  address1?: string | null;
  /**
   * Guarantor Address Line 2, max length 100
   */
  address2?: string | null;
  /**
   * Guarantor City, max length 50
   */
  city?: string | null;
  /**
   * Guarantor State Code, must be a valid US State
   */
  stateCode?: string | null;
  /**
   * Guarantor Zipcode, max length 10
   */
  zip?: string | null;
  /**
   * Guarantor country code
   */
  countryCode?: string | null;
  /**
   * Guarantor home phone number, max length 30
   */
  homePhone?: string | null;
  /**
   * Guarantor work phone number, max length 30
   */
  workPhone?: string | null;
  /**
   * Guarantor mobile phone number, max length 30
   */
  mobilePhone?: string | null;
  /**
   * Guarantor Email Address, max length 100
   */
  email?: string | null;
  /**
   * Option to use alternate mailing address
   */
  useAlternateMailingAddress?: boolean;
  /**
   * Guarantor alternate name, max length 100
   */
  alternateName?: string | null;
  /**
   * Guarantor alternate address line 1, max length 100
   */
  alternateAddress1?: string | null;
  /**
   * Guarantor alternate address line 2, max length 100
   */
  alternateAddress2?: string | null;
  /**
   * Guarantor alternate address city, max length 50
   */
  alternateCity?: string | null;
  /**
   * Guarantor alternate address state code, must be a valid US state
   */
  alternateStateCode?: string | null;
  /**
   * Guarantor alternate address zipcode, max length 10
   */
  alternateZip?: string | null;
  /**
   * Guarantor alternate address country code, max length 20
   */
  alternateCountryCode?: string | null;
  /**
   * Guarantor Employer Name, max length 100
   */
  employerName?: string | null;
  /**
   * Guarantor Employer address line 1, max length 100
   */
  employerAddress1?: string | null;
  /**
   * Guarantor Employer address line 2, max length 100
   */
  employerAddress2?: string | null;
  /**
   * Guarantor Employer city, max length 50
   */
  employerCity?: string | null;
  /**
   * Guarantor Employer state code, must be a valid US state code
   */
  employerStateCode?: string | null;
  /**
   * Guarantor Employer zipcode, max length 10
   */
  employerZip?: string | null;
  /**
   * Guarantor Employer country code, max length 20
   */
  employerCountryCode?: string | null;
  /**
   * Guarantor Employer phone number, max length 30
   */
  employerPhone?: string | null;
  /**
   * Guarantor Employer custom code, max length 20
   */
  employerCode?: string | null;
  /**
   * Emergency Contact First Name, max length 50
   */
  emergencyContactFirstName?: string | null;
  /**
   * Emergency Contact Last Name, max length 50
   */
  emergencyContactLastName?: string | null;
  /**
   * Emergency Contact relation, max length 50
   */
  emergencyContactRelation?: string | null;
  /**
   * Emergency Contact phone number, max length 20
   */
  emergencyContactPhone?: string | null;
  /**
   * Guarantor Driver\'s License number, max length 40
   */
  driverLicenseNumber?: string | null;
  /**
   * If this value is true, patient data is used for the guarantor
   */
  sameAsPatient?: boolean;
}
